import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';

import {FONT_FAMILIES} from '../../../../const';
import useProfile from '../../../../hooks/providers/useProfile';
import OnboardingLastStepCloseModalButton from '../OnboardingLastStepCloseModalButton/OnboardingLastStepCloseModalButton';
import OnboardingMarkStepAsFinishedButton from '../OnboardingMarkStepAsFinishedButton/OnboardingMarkStepAsFinishedButton';
import OnboardingNextStepButton from '../OnboardingNextStepButton/OnboardingNextStepButton';
import OnboardingProgression from '../OnboardingProgression/OnboardingProgression';
import OnboardingSingleFlowVideo from '../OnboardingSingleFlowVideo/OnboardingSingleFlowVideo';

const OnboardingSingleFlowPage = () => {
  const {selectedFlow, currentFlowStep} = useProfile();

  if (!currentFlowStep) return null;

  const currentFlowIndex = selectedFlow.steps.findIndex(s => s.step_id === currentFlowStep.step_id);
  const nextVideo = selectedFlow.steps[currentFlowIndex + 1];

  return (
    <Card
      sx={{
        p: {
          xs: 1,
          sm: 2
        },
        border: '1px solid #DEDEDE',
        borderRadius: 3,
        minHeight: 350,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'scroll'
      }}
    >
      <Box
        style={{
          aspectRatio: '15 / 9',
          width: '100%',
          maxHeight: 350,
          margin: '0 auto',
          borderRadius: 2,
          overflow: 'hidden'
        }}
      >
        {currentFlowStep.url_video ? (
          <OnboardingSingleFlowVideo />
        ) : (
          <img style={{maxWidth: '100%', margin: '0 auto', display: 'block', height: '100%'}} alt="no video for this onboarding step" src={selectedFlow.empty_video} />
        )}
      </Box>
      <Box>
        <OnboardingProgression />
        <Typography fontFamily={FONT_FAMILIES.TITLE} fontSize={15} textAlign="center" mt={2.5}>
          {currentFlowStep.title}
        </Typography>
        <Typography color="text.secondary" fontFamily={FONT_FAMILIES.BODY} fontSize={13.5} textAlign="center" mt={1.5}>
          {currentFlowStep.description}
        </Typography>

        {nextVideo ? (
          <>
            <OnboardingNextStepButton />
            <OnboardingMarkStepAsFinishedButton />
          </>
        ) : (
          <OnboardingLastStepCloseModalButton />
        )}
      </Box>
    </Card>
  );
};

export default OnboardingSingleFlowPage;
